const slideUp = (target, duration = 300) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
};

const slideDown = (target, duration = 300) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
};

export const flipAccorionWithImage = () => {

    const accordionBlocks = document.querySelectorAll('.flip-accordion-w-image-block');
    if (!accordionBlocks.length) return;

    accordionBlocks.forEach(block => {
        const ctaAccordions = block.querySelectorAll('.qa-question');

        ctaAccordions.forEach(cta => {
            cta.addEventListener('click', function (e) {
                e.preventDefault();

                const item = this.closest('.qa-item');
                const dataAccordion = item.getAttribute('data-accordion');
                const imageContainer = block.querySelector('.flip-accordion-w-image-block--images');
                const image = imageContainer.querySelector(`.item-image-${dataAccordion}`);
                const answer = item.querySelector('.qa-answer');

                if (item.classList.contains('qa-item-open')) {
                    if (answer) slideUp(answer);
                    item.classList.remove('qa-item-open');
                } else {
                    const allItems = block.querySelectorAll('.qa-item');
                    allItems.forEach(el => {
                        if (el.classList.contains('qa-item-open')) {
                            el.classList.remove('qa-item-open');
                            const elAnswer = el.querySelector('.qa-answer');
                            if (elAnswer) slideUp(elAnswer);
                        }
                    });

                    if (answer) slideDown(answer);
                    item.classList.add('qa-item-open');

                    const allImages = imageContainer.querySelectorAll('.item-image');
                    allImages.forEach(img => img.classList.remove('active'));
                    if (image) image.classList.add('active');
                }
            });
        });
    });
};


